import { Anchor, Breadcrumbs, Text } from '@cowbell/ui/core';
import { Link } from 'react-router-dom';

import type { SpotlightDetailsPersonaForNavigation } from './spotlightDetails.types';

interface SpotlightDetailsBreadcrumbsProps {
  persona: SpotlightDetailsPersonaForNavigation;
  accountId: string | undefined;
}

export function SpotlightDetailsBreadcrumbs(
  props: SpotlightDetailsBreadcrumbsProps
) {
  const { persona, accountId } = props;

  return (
    <Breadcrumbs {...(persona.isCowbell ? { mt: 'md' } : {})}>
      <Link to={`${persona.basePath}/dashboard`}>
        <Anchor>Dashboard</Anchor>
      </Link>
      {persona.isInsured ? (
        <Link to={`/customer/insights`}>
          <Anchor>Insights</Anchor>
        </Link>
      ) : accountId ? (
        <Link to={`/admin/account/${accountId}/risk-profile`}>
          <Anchor>Account Details</Anchor>
        </Link>
      ) : (
        <Text>Account Details</Text>
      )}
      <Text>Spotlight Details</Text>
    </Breadcrumbs>
  );
}
